import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { sessionStorage } from '@shared/helpers/storage.js'

export const useSharedStore = defineStore(
  'shared',
  () => {
    // State
    /** @type {import('vue').Ref<Object>} */
    const initialQuery = ref({})
    /** @type {import('vue').Ref<Object>} */
    const redirectLink = ref({})

    // Getters
    const utmData = computed(() => ({
      utm_medium: initialQuery.value.utm_medium,
      utm_source: initialQuery.value.utm_source,
      utm_campaign: initialQuery.value.utm_campaign,
      utm_content: initialQuery.value.utm_content,
      utm_term: initialQuery.value.utm_term,
    }))

    // Actions
    function storeInitialQuery(params) {
      initialQuery.value = { ...initialQuery.value, ...params }
    }

    return {
      // State
      initialQuery,
      redirectLink,
      // Getters
      utmData,
      // Actions
      storeInitialQuery,
    }
  },
  {
    persist: {
      storage: sessionStorage,
    },
  },
)

export default useSharedStore
